import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { requestPasswordReset } from '../lib/auth.js';

export function ForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await requestPasswordReset(email);
      navigate(`/reset-password?email=${encodeURIComponent(email)}`, { replace: true });
    } catch (err: unknown) {
      setError(err instanceof Error ? err.message : 'Failed to send reset code');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="max-w-md mx-auto px-6 py-16">
      <h1 className="text-3xl font-display text-brand-800 mb-6">Forgot password</h1>
      <p className="text-sm text-brand-700 mb-4">
        Enter your email and we'll send a verification code so you can set a new password.
      </p>
      <form onSubmit={onSubmit} className="space-y-4">
        <label className="block">
          <span className="block text-sm font-medium text-brand-700 mb-1">Email</span>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            autoFocus
            className="w-full border border-brand-200 px-3 py-2 outline-none focus:border-brand-500 bg-white"
          />
        </label>
        {error && <div className="text-sm text-red-700">{error}</div>}
        <button
          type="submit"
          disabled={submitting}
          className="w-full bg-brand-600 hover:bg-brand-700 disabled:opacity-50 text-white px-4 py-2 font-display font-medium"
        >
          {submitting ? 'Sending…' : 'Send reset code'}
        </button>
        <div className="text-sm">
          <Link to="/login" className="text-brand-600 hover:underline">
            Back to sign in
          </Link>
        </div>
      </form>
    </div>
  );
}
